// extracted by mini-css-extract-plugin
module.exports = {"s1yzraqh":"s1yzraqh","left-arrow-touch":"left-arrow-touch","right-arrow-touch":"right-arrow-touch","slick-slide":"slick-slide","slick-track":"slick-track","a8a0qvn":"a8a0qvn"};